import { QuickRenewConfirmationComponent } from './components/quick-renew-confirmation';
import { Routes } from '@angular/router';
import { PageLogoHeaderComponent } from '../share/page-logo-header/page-logo-header.component';
import checkPayment from './guards/check-payment';
import checkConfirmation from './guards/check-confirmation';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/quick-renew-form.component').then((m) => m.QuickRenewFormComponent),
  },
  {
    path: 'payment',
    loadComponent: () =>
      import('./components/quick-renew-payment-form.component').then((m) => m.QuickRenewPaymentFormComponent),
    canActivate: [checkPayment],
  },
  {
    path: 'confirmation',
    component: QuickRenewConfirmationComponent,
    canActivate: [checkConfirmation],
  },
  {
    path: '',
    component: PageLogoHeaderComponent,
    outlet: 'header',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
